import React from 'react'
import ErrorPage from 'pages/DefaultErrorPage/DefaultErrorPage'
import Mark from 'assets/mark.svg'

const UnsuportedBrowser = () => {
  return (
    <ErrorPage
      img={{
        src: Mark,
        alt: 'Navegador incompatível',
      }}
      action="Navegador incompatível"
      body="Estou trabalhando para melhorar o acesso com este navegador. Enquanto isso, troque de navegador para acessar os serviços da plataforma."
    />
  )
}

export default UnsuportedBrowser
